/**
 * CoinGate API utilities
 */

import { supabase } from './supabaseClient';

const getAuthHeaders = async () => {
  // Get session token from Supabase
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token || localStorage.getItem('auth_token');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

/**
 * Connect CoinGate (create beneficiary and payout setting)
 */
export const connectCoinGate = async (connectionData) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch('/api/coingate/connect', {
      method: 'POST',
      headers,
      body: JSON.stringify(connectionData),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || result.details || 'Failed to connect CoinGate');
    }

    return result;
  } catch (error) {
    console.error('Error connecting CoinGate:', error);
    throw error;
  }
};

/**
 * Get CoinGate connection status
 */
export const getCoinGateStatus = async () => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch('/api/coingate/status', {
      method: 'GET',
      headers,
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || 'Failed to get CoinGate status');
    }

    return result;
  } catch (error) {
    console.error('Error getting CoinGate status:', error);
    throw error;
  }
};

/**
 * Add a new CoinGate payout setting (for additional crypto currencies)
 */
export const addCoinGatePayoutSetting = async (payoutData) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch('/api/coingate/add-payout-setting', {
      method: 'POST',
      headers,
      body: JSON.stringify(payoutData),
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || result.details || 'Failed to add payout setting');
    }

    return result;
  } catch (error) {
    console.error('Error adding CoinGate payout setting:', error);
    throw error;
  }
};

/**
 * Remove a CoinGate payout setting
 */
export const removeCoinGatePayoutSetting = async (payoutSettingId) => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch(`/api/coingate/remove-payout-setting?payout_setting_id=${payoutSettingId}`, {
      method: 'DELETE',
      headers,
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || result.details || 'Failed to remove payout setting');
    }

    return result;
  } catch (error) {
    console.error('Error removing CoinGate payout setting:', error);
    throw error;
  }
};

/**
 * Disconnect CoinGate entirely
 */
export const disconnectCoinGate = async () => {
  try {
    const headers = await getAuthHeaders();
    const response = await fetch('/api/coingate/disconnect', {
      method: 'POST',
      headers,
    });

    const result = await response.json();
    if (!response.ok) {
      throw new Error(result.error || result.details || 'Failed to disconnect CoinGate');
    }

    return result;
  } catch (error) {
    console.error('Error disconnecting CoinGate:', error);
    throw error;
  }
};

